import React from 'react';

export default class Tag extends React.Component {
    render() {
        let classes = ['Tag', this.props.className],
        style = Object.assign( {}, this.props.style);
        return <div className={classes.join(' ')} style={style}>{this.props.children}</div>;
    }
}
